import Image from '../atoms/Image'
import { MotifCard, MotifCardBody } from '@ey-xd/motif-react'
import React from 'react'
import { useDispatch } from 'react-redux';

const ServiceCard = ({image, title, subtitle, disabled}) => {
    const dispatch = useDispatch();
    const onClick= () => {
        if(disabled) return;
        dispatch({type: "CONVERSATION_MESSAGE_SEND", payload: { text: title }});
    }
    return (
        <MotifCard onClick={onClick}
            className={`!h-full !rounded-none ${disabled ? "" : "hover:!border-ey-yellow"} !border-t-0 !border-b-4 !border-x-0 ${disabled ? "!bg-[#7a7a7a42]/5" : "!bg-[#7a7a7a42]/10"} cursor-pointer group ${disabled ? "" : "hover:!bg-[#7a7a7a42]/15"}`}>
            <MotifCardBody className="text-center flex items-center flex-col">
                <Image src={image} className="group-hover:rotate-[10deg]" />
                <h4 className="text-lg font-bold conversation-start-service-title my-2">{title}</h4>
                <p className="text-sm">
                    {subtitle}
                </p>
            </MotifCardBody>
        </MotifCard>
    )
}

export default ServiceCard